import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AppNavComponent } from '../../shared/app-nav.component';
import { TranslatePipe } from '../../shared/translate.pipe';

@Component({
  standalone: true,
  imports: [RouterLink, AppNavComponent, TranslatePipe],
  template: `
        <app-nav></app-nav>
    <main class="page-shell">
      <header class="topbar">
        <h1>{{ 'dashboard.title' | t }}</h1>
      </header>
      <section class="dashboard-grid">
        <a class="module-card" routerLink="/truck-announcements">
          <svg class="module-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="1.5" y="7" width="13" height="9" rx="1"/><path d="M14.5 10h3.5l3 3v3h-6.5z"/><circle cx="6" cy="18.5" r="1.6" fill="currentColor" stroke="none"/><circle cx="17.5" cy="18.5" r="1.6" fill="currentColor" stroke="none"/></svg>
          <strong>{{ 'nav.truckAnnouncements' | t }}</strong><span>{{ 'common.openModule' | t }}</span>
        </a>
        <a class="module-card" routerLink="/vessel-announcements">
          <svg class="module-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="4" r="2"/><path d="M12 6v14"/><path d="M8 9h8"/><path d="M5 13a7 7 0 0 0 14 0"/></svg>
          <strong>{{ 'nav.vesselAnnouncements' | t }}</strong><span>{{ 'common.openModule' | t }}</span>
        </a>
        <a class="module-card" routerLink="/work-orders">
          <svg class="module-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M8 8V6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><rect x="3" y="8" width="18" height="11" rx="1.5"/><path d="M3 13h18"/></svg>
          <strong>{{ 'dashboard.workOrders' | t }}</strong><span>{{ 'common.openModule' | t }}</span>
        </a>
        <a class="module-card" routerLink="/service-requests">
          <svg class="module-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M6.5 2.5h8l4 4v14a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-17a1 1 0 0 1 1-1z"/><path d="M14.5 2.5v4h4"/><path d="M8 12.5h8"/><path d="M8 16.5h8"/></svg>
          <strong>{{ 'nav.serviceRequests' | t }}</strong><span>{{ 'common.openModule' | t }}</span>
        </a>
        <a class="module-card" routerLink="/permits">
          <svg class="module-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="7" cy="14" r="4"/><path d="M10.3 10.7 20 1"/><path d="M16 5l3 3"/><path d="M13.3 7.7l3 3"/></svg>
          <strong>{{ 'nav.permits' | t }}</strong><span>{{ 'common.openModule' | t }}</span>
        </a>
        <a class="module-card" routerLink="/container-use">
          <svg class="module-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2.5 20.5 7v10L12 21.5 3.5 17V7z"/><path d="M12 12v9.5"/><path d="M3.5 7 12 12l8.5-5"/></svg>
          <strong>{{ 'nav.containerUse' | t }}</strong><span>{{ 'common.openModule' | t }}</span>
        </a>
      </section>
    </main>
  `
})
export class DashboardPage {}
